/* hub-rescue-loader 20260724-verify-d */
(function () {
  if (window.__teaQuizHubRescueConstitutionBootV5) return;
  window.__teaQuizHubRescueConstitutionBootV5 = 1;

  function assetPrefix() {
    var ref =
      document.querySelector('script[src*="quiz-hub-rescue-v1.js"]') ||
      document.querySelector('script[src*="quiz-constitution-live-fix-v1.js"]') ||
      document.querySelector('script[src*="tea-quiz-constitution-hub-v13.js"]');
    if (!ref || !ref.src || ref.src.indexOf('/assets/') === -1) return '';
    return ref.src.split('/assets/')[0] + '/assets/';
  }

  function loadScript(fileName, attr) {
    if (document.querySelector('script[' + attr + ']')) return;
    var prefix = assetPrefix();
    if (!prefix) return;
    var script = document.createElement('script');
    script.src = prefix + fileName + '?hubv=5&_=' + Date.now();
    script.async = false;
    script.setAttribute(attr, '');
    document.head.appendChild(script);
  }

  loadScript('tea-quiz-fresh-home-v1.js', 'data-tea-quiz-fresh-home-v1');
  loadScript('tea-quiz-logo-home-nav-v1.js', 'data-tea-quiz-logo-home-nav-v1');
  loadScript('quiz-constitution-live-fix-v12.js', 'data-tea-quiz-live-fix-v12');

  if (!window.__teaQuizConstitutionIsResultInlineV1) {
    window.__teaQuizConstitutionIsResultInlineV1 = 1;

    function storeRoot() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root.charAt(root.length - 1) === '/' ? root : root + '/';
    }

    function hubUrl() {
      return storeRoot() + '?from=quiz&view=quiz-results#quiz-results';
    }

    function isExplicitRetake() {
      try {
        if (sessionStorage.getItem('teaQuizExplicitRetake') === '1') return true;
        if (sessionStorage.getItem('teaQuizBlockRedirect') === '1') return true;
        if (window.location.search.indexOf('_teaquizretake=') >= 0) return true;
      } catch (error) {}
      return false;
    }

    function isHubDismissedUntilRetake() {
      if (window.__teaQuizIsHubDismissedUntilRetake) {
        return window.__teaQuizIsHubDismissedUntilRetake();
      }
      try {
        if (sessionStorage.getItem('teaQuizDismissedUntilRetake') === '1') return true;
      } catch (error) {}
      return window.location.search.indexOf('_teahome=') >= 0;
    }

    function injectHideStyles() {
      if (document.getElementById('tea-quiz-constitution-isresult-inline-css')) return;
      var style = document.createElement('style');
      style.id = 'tea-quiz-constitution-isresult-inline-css';
      style.textContent =
        'html.quiz-results-from-quiz #quiz,' +
        'html.quiz-results-from-quiz #quiz-container,' +
        'html.quiz-results-from-quiz #shadow-quiz,' +
        'html.quiz-results-from-quiz .shopify-section:has(#quiz),' +
        'html.quiz-results-from-quiz .shopify-section:has(#shadow-quiz){display:none!important;}' +
        'html.quiz-results-from-quiz .quiz-constitution-results-section,' +
        'html.quiz-results-from-quiz #quiz-results,' +
        'html.quiz-results-from-quiz [data-quiz-constitution-results],' +
        'html.quiz-results-from-quiz .quiz-constitution-results{display:block!important;}' +
        'html.quiz-results-from-quiz.tea-quiz-take-mode #quiz,' +
        'html.quiz-results-from-quiz.tea-quiz-take-mode #shadow-quiz{display:none!important;}';
      document.head.appendChild(style);
    }

    function hideNativeQuizTeaResult() {
      if (isHubDismissedUntilRetake()) return;
      if (isExplicitRetake()) return;
      injectHideStyles();
      document.documentElement.classList.add('quiz-results-from-quiz');
      document.documentElement.classList.remove('tea-quiz-take-mode');
      window.__teaQuizPendingConstitutionHub = 1;

      document
        .querySelectorAll('#shadow-quiz, #quiz #shadow-quiz, #quiz-container #shadow-quiz, #quiz, #quiz-container')
        .forEach(function (node) {
          node.style.setProperty('display', 'none', 'important');
        });

      document
        .querySelectorAll('#shadow-quiz, #quiz #shadow-quiz, #quiz-container #shadow-quiz')
        .forEach(function (host) {
          if (!host.shadowRoot || host.shadowRoot.querySelector('#tea-quiz-inline-hide-style')) return;
          var shadowStyle = document.createElement('style');
          shadowStyle.id = 'tea-quiz-inline-hide-style';
          shadowStyle.textContent =
            '.quiz,.quiz *,.quiz-result,.quiz-result *,.result-page,.result-page *,' +
            '.navigation-bar,.navigation-bar *,a[href*="/products/"],' +
            '.tea-quiz-recommendations-mount,.tea-quiz-recommendations-mount *,' +
            '.tea-recommendations,.tea-recommendations *{display:none!important;visibility:hidden!important;' +
            'height:0!important;overflow:hidden!important;pointer-events:none!important;}';
          host.shadowRoot.appendChild(shadowStyle);
        });

      document
        .querySelectorAll('[data-tea-quiz-injected-inline], [data-tea-quiz-injected-popup]')
        .forEach(function (node) {
          node.remove();
        });

      try {
        if (window.location.hash === '#quiz' || window.location.search.indexOf('view=quiz-results') === -1) {
          history.replaceState({ teaQuizHub: 1 }, '', hubUrl());
        }
      } catch (error) {}

      if (window.__teaQuizTriggerConstitutionHub) {
        window.__teaQuizTriggerConstitutionHub({ force: true });
      } else if (window.__teaQuizSuppressNativeQuizTeaResult) {
        window.__teaQuizSuppressNativeQuizTeaResult();
      } else if (window.TeaQuizConstitutionHub && window.TeaQuizConstitutionHub.showHubInPlace) {
        window.TeaQuizConstitutionHub.showHubInPlace({ force: true });
      }
    }

    window.__teaQuizInlineHideNativeQuizTeaResult = hideNativeQuizTeaResult;

    window.addEventListener(
      'message',
      function (event) {
        var data = event.data;
        if (!data || data.channel !== 'revenuehunt:quiz-renderer' || data.type !== 'isResult') return;
        if (isHubDismissedUntilRetake()) return;
        if (isExplicitRetake()) return;
        event.stopImmediatePropagation();
        hideNativeQuizTeaResult();
      },
      true
    );

    function shadowLooksLikeTeaResult(shadowRoot) {
      if (!shadowRoot) return false;
      if (shadowRoot.querySelector('.quiz-question')) return false;
      if (shadowRoot.querySelector('.quiz-result, .result-page, .quiz.results')) return true;
      return !shadowRoot.querySelector('.quiz-question') && shadowRoot.querySelector('a[href*="/products/"]');
    }

    function pollQuizResultSurface() {
      if (isHubDismissedUntilRetake()) return;
      if (isExplicitRetake()) return;
      if (document.documentElement.classList.contains('quiz-results-from-quiz')) return;
      var hosts = document.querySelectorAll('#shadow-quiz, #quiz #shadow-quiz, #quiz-container #shadow-quiz');
      for (var i = 0; i < hosts.length; i++) {
        var shadowRoot = hosts[i].shadowRoot;
        if (shadowRoot && shadowLooksLikeTeaResult(shadowRoot)) {
          hideNativeQuizTeaResult();
          return;
        }
      }
    }

    injectHideStyles();
    function startRescuePollers() {
      if (window.__teaQuizStopInlinePollers) return;
      if (window.__teaQuizConstitutionIsResultInlineV1) return;
      var rescuePollTimer = null;
      var rescuePollCount = 0;
      rescuePollTimer = window.setInterval(function () {
        if (window.__teaQuizIsHubStable && window.__teaQuizIsHubStable()) {
          window.clearInterval(rescuePollTimer);
          return;
        }
        rescuePollCount += 1;
        if (rescuePollCount >= 120) {
          window.clearInterval(rescuePollTimer);
          return;
        }
        pollQuizResultSurface();
        flushPendingHub();
      }, 500);
    }
    startRescuePollers();
    document.addEventListener('DOMContentLoaded', pollQuizResultSurface);
    window.addEventListener('load', pollQuizResultSurface);

    function flushPendingHub() {
      if (!window.__teaQuizPendingConstitutionHub) return;
      if (window.__teaQuizTriggerConstitutionHub) {
        window.__teaQuizTriggerConstitutionHub({ force: true });
      } else if (window.TeaQuizConstitutionHub && window.TeaQuizConstitutionHub.mountHubPage) {
        window.TeaQuizConstitutionHub.mountHubPage();
      }
    }

    window.addEventListener('load', flushPendingHub);
  }
})();

(function () {
  window.__teaQuizHubRedirectLock = 0;
  try {
    sessionStorage.removeItem('teaQuizHubRedirectLock');
  } catch (error) {}

  if (!window.__teaQuizTakeModeBootV1) {
    window.__teaQuizTakeModeBootV1 = 1;

    function isQuizTakeMode() {
      if (window.location.hash === '#quiz') return true;
      if (window.location.search.indexOf('_teaquizretake=') >= 0) return true;
      try {
        if (sessionStorage.getItem('teaQuizExplicitRetake') === '1') return true;
        if (sessionStorage.getItem('teaQuizBlockRedirect') === '1') return true;
      } catch (error) {}
      return false;
    }

    function isResultsHubUrl() {
      if (window.location.search.indexOf('from=quiz') === -1) return false;
      try {
        return new URLSearchParams(window.location.search).get('view') === 'quiz-results';
      } catch (error) {
        return window.location.search.indexOf('view=quiz-results') !== -1;
      }
    }

    function restoreQuizVisibility() {
      document
        .querySelectorAll(
          '#quiz, #quiz-container, #shadow-quiz, #quiz #shadow-quiz, #quiz-container #shadow-quiz, .shopify-section:has(#quiz), .shopify-section:has(#shadow-quiz)'
        )
        .forEach(function (node) {
          node.style.removeProperty('display');
        });
    }

    function enableTakeMode() {
      document.documentElement.classList.add('tea-quiz-take-mode');
      document.documentElement.classList.remove('quiz-results-from-quiz');
      restoreQuizVisibility();
    }

    window.__teaQuizEnableTakeMode = window.__teaQuizEnableTakeMode || enableTakeMode;

    function applyPageMode() {
      function hasPersistedHubResults() {
        try {
          return !!(
            sessionStorage.getItem('teaQuizConstitutionResults') ||
            localStorage.getItem('teaQuizConstitutionResults')
          );
        } catch (error) {
          return false;
        }
      }

      function isExplicitQuizRetake() {
        try {
          if (sessionStorage.getItem('teaQuizExplicitRetake') === '1') return true;
          if (sessionStorage.getItem('teaQuizBlockRedirect') === '1') return true;
          if (window.location.search.indexOf('_teaquizretake=') >= 0) return true;
        } catch (error) {}
        return false;
      }

      function isHubConstitutionHash() {
        var hash = window.location.hash || '';
        if (hash === '#quiz-results') return true;
        return hash.indexOf('#constitution-hub-') === 0;
      }

      function shouldKeepHubView() {
        if (window.__teaQuizShouldKeepHubResultsView && window.__teaQuizShouldKeepHubResultsView()) {
          return true;
        }
        if (!hasPersistedHubResults() || isExplicitQuizRetake()) return false;
        if (isResultsHubUrl()) return true;
        if (isHubConstitutionHash()) return true;
        if (document.documentElement.classList.contains('quiz-results-from-quiz')) return true;
        if (window.__teaQuizResolvedPageMode === 'hub') return true;
        return false;
      }

      var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
      var rootPath = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '') || '/';

      if (shouldKeepHubView()) {
        document.documentElement.classList.add('quiz-results-from-quiz');
        document.documentElement.classList.remove('tea-quiz-take-mode');
        var hubHash = window.location.hash || '';
        if (hubHash.indexOf('#constitution-hub-') === 0 && window.__teaQuizScrollToConstitutionSection) {
          window.__teaQuizScrollToConstitutionSection(hubHash.slice(1), 'smooth');
        } else if (window.__teaQuizApplyHubResultsView) {
          window.__teaQuizApplyHubResultsView();
        } else if (window.__teaQuizRestoreHubAfterNavigation) {
          window.__teaQuizRestoreHubAfterNavigation();
        }
        return;
      }

      if (window.__teaQuizShouldShowHubPage && window.__teaQuizShouldShowHubPage()) {
        document.documentElement.classList.add('quiz-results-from-quiz');
        document.documentElement.classList.remove('tea-quiz-take-mode');
        if (window.__teaQuizRestoreHubAfterNavigation) {
          window.__teaQuizRestoreHubAfterNavigation();
        }
        return;
      }

      if (window.__teaQuizIsHubDismissedUntilRetake && window.__teaQuizIsHubDismissedUntilRetake()) {
        if (window.__teaQuizApplyNormalHomeShell) {
          window.__teaQuizApplyNormalHomeShell();
        } else {
          document.documentElement.classList.remove('quiz-results-from-quiz', 'tea-quiz-take-mode');
        }
        restoreQuizVisibility();
        return;
      }

      if ((path === '/' || path === rootPath) && window.__teaQuizResolvedPageMode === 'home') {
        if (window.__teaQuizApplyNormalHomeShell) {
          window.__teaQuizApplyNormalHomeShell();
        } else {
          document.documentElement.classList.remove('quiz-results-from-quiz', 'tea-quiz-take-mode');
        }
        restoreQuizVisibility();
        return;
      }

      if (isResultsHubUrl() && hasPersistedHubResults()) {
        document.documentElement.classList.add('quiz-results-from-quiz');
        document.documentElement.classList.remove('tea-quiz-take-mode');
        if (window.__teaQuizRestoreHubAfterNavigation) {
          window.__teaQuizRestoreHubAfterNavigation();
        }
        return;
      }

      if (isQuizTakeMode()) {
        enableTakeMode();
        if (isResultsHubUrl()) {
          var qs = window.location.search.indexOf('_teaquizretake=') >= 0 ? '?_teaquizretake=1' : '';
          try {
            history.replaceState(null, '', window.location.pathname + qs + '#quiz');
          } catch (error) {}
        }
        return;
      }

      if (!isResultsHubUrl() && !isHubConstitutionHash()) {
        document.documentElement.classList.remove('quiz-results-from-quiz');
        document.documentElement.classList.remove('tea-quiz-take-mode');
        restoreQuizVisibility();
      }
    }

    if (!document.getElementById('tea-quiz-take-mode-rescue-css')) {
      var rescueStyle = document.createElement('style');
      rescueStyle.id = 'tea-quiz-take-mode-rescue-css';
      rescueStyle.textContent =
        'html.tea-quiz-take-mode .quiz-constitution-results-section,' +
        'html.tea-quiz-take-mode #quiz-results,' +
        'html.tea-quiz-take-mode [data-quiz-constitution-results]{display:none!important;}' +
        'html.tea-quiz-take-mode #MainContent>.shopify-section{display:block!important;}' +
        'html.tea-quiz-take-mode #quiz,' +
        'html.tea-quiz-take-mode #quiz-container,' +
        'html.tea-quiz-take-mode #shadow-quiz,' +
        'html.tea-quiz-take-mode .shopify-section:has(#quiz),' +
        'html.tea-quiz-take-mode .shopify-section:has(#shadow-quiz){display:block!important;}' +
        'html.quiz-results-from-quiz.tea-quiz-take-mode #MainContent>.shopify-section{display:block!important;}' +
        'html.quiz-results-from-quiz.tea-quiz-take-mode .shopify-section:has(#quiz),' +
        'html.quiz-results-from-quiz.tea-quiz-take-mode .shopify-section:has(#shadow-quiz){display:block!important;}';
      document.head.appendChild(rescueStyle);
    }

    applyPageMode();
    window.addEventListener('hashchange', applyPageMode);
    document.addEventListener('DOMContentLoaded', applyPageMode);
    window.addEventListener('load', applyPageMode);
  }

  if (!window.__teaQuizConstitutionOrchestratorV1) {
    window.__teaQuizConstitutionOrchestratorV1 = 1;

    var HUB_VIEW = 'quiz-results';

    function orchestratorGetRoot() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root.charAt(root.length - 1) === '/' ? root : root + '/';
    }

    function orchestratorBuildHubUrl() {
      return orchestratorGetRoot() + '?from=quiz&view=' + HUB_VIEW;
    }

    function shouldSkipQuizToHub() {
      if (window.location.hash === '#quiz') return true;
      if (document.documentElement.classList.contains('tea-quiz-take-mode')) return true;
      try {
        if (window.location.search.indexOf('_teaquizretake=') >= 0) return true;
        if (sessionStorage.getItem('teaQuizBlockRedirect') === '1') return true;
        if (sessionStorage.getItem('teaQuizExplicitRetake') === '1') return true;
      } catch (error) {}
      return false;
    }

    function suppressNativeQuizResultUi() {
      document
        .querySelectorAll('#shadow-quiz, #quiz #shadow-quiz, #quiz-container #shadow-quiz')
        .forEach(function (host) {
          host.style.setProperty('display', 'none', 'important');
          if (!host.shadowRoot || host.shadowRoot.querySelector('#tea-quiz-orchestrator-hide-style')) return;
          var style = document.createElement('style');
          style.id = 'tea-quiz-orchestrator-hide-style';
          style.textContent =
            '.quiz.quiz-result,.quiz.quiz-result *,.quiz.results,.quiz.results *,' +
            '.quiz-result,.quiz-result *,.result-page,.result-page *,' +
            '.navigation-bar,.navigation-bar *,' +
            '.tea-quiz-recommendations-mount,.tea-quiz-recommendations-mount *,' +
            '.tea-recommendations,.tea-recommendations *{display:none!important;visibility:hidden!important;' +
            'height:0!important;overflow:hidden!important;pointer-events:none!important;}';
          host.shadowRoot.appendChild(style);
        });
    }

    function beginHubTransitionShell() {
      var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
      var rootPath = orchestratorGetRoot().replace(/\/$/, '') || '/';
      if (path === '/' || path === rootPath) {
        try {
          history.replaceState(null, '', orchestratorBuildHubUrl());
        } catch (error) {}
      }
      document.documentElement.classList.add('quiz-results-from-quiz');
      suppressNativeQuizResultUi();
      if (window.__teaQuizClearRedirectOverlay) {
        window.__teaQuizClearRedirectOverlay();
      }
    }

    function orchestratorAssetBase() {
      var ref = document.querySelector('script[src*="quiz-hub-rescue-v1"]');
      if (ref && ref.src) {
        return ref.src.replace(/[^/]+$/, '');
      }
      return orchestratorGetRoot() + 'cdn/shop/t/8/assets/';
    }

    function ensureHubModule(callback) {
      if (window.TeaQuizConstitutionHub) {
        callback(window.TeaQuizConstitutionHub);
        return;
      }

      if (!window.__teaQuizHubModuleLoadPromise) {
        window.__teaQuizHubModuleLoadPromise = new Promise(function (resolve) {
          var script = document.createElement('script');
          script.src = orchestratorAssetBase() + 'tea-quiz-constitution-hub-v13.js?_=' + Date.now();
          script.async = false;
          script.onload = function () {
            resolve(window.TeaQuizConstitutionHub || null);
          };
          script.onerror = function () {
            resolve(null);
          };
          document.head.appendChild(script);
        });
      }

      window.__teaQuizHubModuleLoadPromise.then(function (hub) {
        callback(hub);
      });
    }

    function reclaimGlobals(hub) {
      if (!hub) return;
      window.__teaQuizPaintHubNow = hub.showHubInPlace;
      window.__teaQuizTryRedirectToResultsHub = function () {
        hub.showHubInPlace();
        return true;
      };
      window.__teaQuizIsOnHubResultsPage = function () {
        try {
          return new URLSearchParams(window.location.search).get('view') === HUB_VIEW;
        } catch (error) {
          return window.location.search.indexOf('view=' + HUB_VIEW) !== -1;
        }
      };
      window.__teaQuizClearRedirectOverlay = window.__teaQuizClearRedirectOverlay || function () {};
    }

    function triggerHubTransition(options) {
      options = options || {};
      if (!options.force && shouldSkipQuizToHub()) return;
      beginHubTransitionShell();
      ensureHubModule(function (hub) {
        if (!hub) return;
        reclaimGlobals(hub);
        if (typeof hub.showHubInPlace === 'function') {
          hub.showHubInPlace({ force: !!options.force });
        }
      });
    }

    window.__teaQuizTriggerConstitutionHub = triggerHubTransition;

    window.addEventListener(
      'message',
      function (event) {
        var data = event.data;
        if (!data || data.channel !== 'revenuehunt:quiz-renderer') return;
        if (data.type === 'isResult') {
          event.stopImmediatePropagation();
          triggerHubTransition({ force: true });
        }
      },
      true
    );

    ensureHubModule(function (hub) {
      reclaimGlobals(hub);
    });
  }

  if (window.__teaQuizHubRescueV2) return;
  window.__teaQuizHubRescueV2 = 1;

  var HUB_PAGE = 'pages/quiz-results';
  var HUB_VIEW = 'quiz-results';
  var STORAGE_KEY = 'teaQuizConstitutionResults';
  var SECTION_ID = 'template--26698830250095__quiz_constitution_results_hub';

  function getRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function buildHubPageUrl() {
    return getRoot() + HUB_PAGE + '?from=quiz';
  }

  function isLegacyHomeHubUrl() {
    var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
    var root = getRoot().replace(/\/$/, '') || '/';
    if (path !== '/' && path !== root) return false;
    try {
      return (
        window.location.search.indexOf('from=quiz') !== -1 &&
        new URLSearchParams(window.location.search).get('view') === HUB_VIEW
      );
    } catch (error) {
      return (
        window.location.search.indexOf('from=quiz') !== -1 &&
        window.location.search.indexOf('view=' + HUB_VIEW) !== -1
      );
    }
  }

  function isHubResultsPage() {
    var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
    var root = getRoot().replace(/\/$/, '') || '/';
    if (path === '/' + HUB_PAGE || path === root + '/' + HUB_PAGE) return true;
    return isLegacyHomeHubUrl();
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildDetailUrl(name) {
    return getRoot() + 'collections/' + encodeURIComponent(name) + '?from=quiz&view=detail#constitution-info';
  }

  function readPersistedResults() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.qualified) || !parsed.qualified.length) return null;
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function findHubRoot() {
    return (
      document.querySelector('.quiz-constitution-results-section [data-quiz-constitution-results]') ||
      document.querySelector('#quiz-results [data-quiz-constitution-results]') ||
      document.querySelector('[data-quiz-constitution-results]')
    );
  }

  function needsPaint(root) {
    if (!root) return true;
    if (root.querySelector('.quiz-constitution-results__toc-wrap')) return false;
    if (root.querySelector('.quiz-constitution-results__grid')) return false;
    if (root.querySelector('.quiz-constitution-results__loading-text')) return true;
    return true;
  }

  function renderHub(root) {
    if (!root || !needsPaint(root)) return;

    if (window.__teaQuizRenderConstitutionHub) {
      window.__teaQuizRenderConstitutionHub(root);
      return;
    }

    if (window.TeaQuizConstitutionHub && window.TeaQuizConstitutionHub.renderHub) {
      window.TeaQuizConstitutionHub.renderHub(root);
    }
  }

  function runScripts(container) {
    if (!container) return;
    container.querySelectorAll('script').forEach(function (oldScript) {
      var script = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes, function (attr) {
        script.setAttribute(attr.name, attr.value);
      });
      script.text = oldScript.textContent;
      oldScript.parentNode.replaceChild(script, oldScript);
    });
  }

  function hydrateFromSectionApi() {
    var liveRoot = findHubRoot();
    if (!needsPaint(liveRoot)) return;

    var url =
      window.location.pathname +
      '?sections=' +
      encodeURIComponent(SECTION_ID) +
      '&from=quiz&view=quiz-results&_=' +
      Date.now();

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var html = data && data[SECTION_ID];
        if (!html) return;

        var wrap = document.createElement('div');
        wrap.innerHTML = html;
        runScripts(wrap);

        liveRoot = findHubRoot();
        var apiRoot = wrap.querySelector('[data-quiz-constitution-results]');
        if (liveRoot && apiRoot) {
          liveRoot.innerHTML = apiRoot.innerHTML;
          runScripts(liveRoot.closest('section') || liveRoot.parentElement || liveRoot);
        }
        renderHub(findHubRoot());
      })
      .catch(function () {});
  }

  function mountHub() {
    if (!isHubResultsPage()) return;

    document.documentElement.classList.add('quiz-results-from-quiz');
    if (window.__teaQuizClearRedirectOverlay) {
      window.__teaQuizClearRedirectOverlay();
    }

    if (window.TeaQuizConstitutionHub && window.TeaQuizConstitutionHub.mountHubPage) {
      window.TeaQuizConstitutionHub.mountHubPage();
    }

    renderHub(findHubRoot());
    hydrateFromSectionApi();
  }

  function boot() {
    mountHub();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.setTimeout(boot, 300);
  window.setTimeout(boot, 1200);
  window.addEventListener('pageshow', boot);
})();
